import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.lpsysadmin.lips.company.list');
import { Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-lpsysadmin-lips-company-list',
template: templateSource || '',
    styles: [`

/* file: /opt/app/project/main/build/src/app/portal.lpsysadmin.lips.company.list/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PortalLpsysadminLipsCompanyListComponent implements OnInit, OnChanges {
    @Input() status: string = 'recommended';

    constructor(@Inject( Service) public service: Service) { }

    public initialized: boolean = false;
    public loaded: boolean = false;
    public loading: boolean = false;
    public saving: boolean = false;
    public lookupLoading: boolean = false;
    public modalOpen: boolean = false;
    public notificationOpen: boolean = false;
    public notificationSending: boolean = false;
    public rows: any[] = [];
    public selectedIds: any = {};
    public sourceCompanies: any[] = [];
    public sourceLoading: boolean = false;
    public sourceLoaded: boolean = false;
    public sourceOpen: boolean = false;
    public sourceError: string = '';
    public sourceFilter: string = 'all';
    public sourceSearch: string = '';
    public title: string = '추천 기업';
    public search: any = { text: '', page: 1, dump: 20 };
    public pagination: any = { start: -1, end: -1, current: 1 };
    public form: any = this.emptyForm();
    public notification: any = this.emptyNotification();
    public foundSource: any = null;

    public statusConfig: any = {
        recommended: { title: '추천 기업', badge: '추천', cls: 'bg-cyan-50 text-cyan-700 border-cyan-200' },
        selected: { title: '선정 기업', badge: '선정', cls: 'bg-sky-50 text-sky-700 border-sky-200' },
        graduated: { title: '졸업 기업', badge: '졸업', cls: 'bg-zinc-100 text-zinc-700 border-zinc-200' }
    };

    public statusOptions: any[] = [
        { value: 'recommended', label: '추천 기업' },
        { value: 'selected', label: '선정 기업' },
        { value: 'graduated', label: '졸업 기업' }
    ];

    public async ngOnInit() {
        await this.service.init();
        this.initialized = true;
        await this.load(1);
    }

    public async ngOnChanges(changes: SimpleChanges) {
        if (!this.initialized || !changes.status) return;
        await this.load(1);
    }

    public get config() {
        return this.statusConfig[this.status] || this.statusConfig.recommended;
    }

    public get modalTitle(): string {
        const config = this.statusConfig[this.form.status] || this.config;
        return `립스 ${config.title} ${this.form.id ? '수정' : '등록'}`;
    }

    public emptyForm(status: string = this.status || 'recommended') {
        return {
            id: '',
            status,
            source_company_id: '',
            registed_number: '',
            company_name: '',
            product: '',
            description: '',
            ceo: '',
            ceo_phone: '',
            manager: '',
            manager_email: '',
            manager_phone: '',
            contacts: [],
            logo_image: '',
            featured_image: '',
            ir_file: '',
            requester: '',
            task_number: '',
            residency_status: '',
            lips_manager: '',
            recommended_month: '',
            operating_period: '',
            investment_amount: '',
            program_name: '',
            lead_manager: '',
            recommendation_reason: '',
            selection_date: '',
            graduation_date: '',
            memo: ''
        };
    }

    public emptyNotification(rows: any[] = []) {
        return {
            ids: rows.map((row: any) => row.id).filter((id: any) => !!id),
            to: '',
            subject: '립스 안내',
            message: '',
            attachments: []
        };
    }

    public statusLabel(value: string): string {
        const config = this.statusConfig[value] || this.statusConfig.recommended;
        return config.title;
    }

    public showSelectedColumns(): boolean {
        return ['selected', 'graduated'].includes(this.status || '');
    }

    public tableColspan(): number {
        return this.showSelectedColumns() ? 12 : 9;
    }

    public lipsManagerLabel(row: any): string {
        return row?.lips_manager || row?.lead_manager || row?.manager || '-';
    }

    public baseSummaryText(row: any): string {
        const summary = row?.base_summary || {};
        return `${summary.completed || 0}/${summary.total || 4}`;
    }

    public baseSummaryClass(row: any): string {
        const completed = Number(row?.base_summary?.completed || 0);
        if (completed >= 4) return 'border-emerald-200 bg-emerald-50 text-emerald-700';
        if (completed > 0) return 'border-cyan-200 bg-cyan-50 text-cyan-700';
        return 'border-zinc-200 bg-zinc-50 text-zinc-500';
    }

    public requestSummaryText(row: any): string {
        const summary = row?.request_summary || {};
        if (summary.overdue) return `초과 ${summary.overdue}`;
        if (summary.submitted) return `제출 ${summary.submitted}`;
        if (summary.active) return `진행 ${summary.active}`;
        return summary.total ? `완료 ${summary.completed || 0}` : '-';
    }

    public requestSummaryClass(row: any): string {
        const summary = row?.request_summary || {};
        if (summary.overdue) return 'border-red-200 bg-red-50 text-red-700';
        if (summary.submitted) return 'border-emerald-200 bg-emerald-50 text-emerald-700';
        if (summary.active) return 'border-sky-200 bg-sky-50 text-sky-700';
        return 'border-zinc-200 bg-zinc-50 text-zinc-500';
    }

    public async loadSourceCompanies(text: string = '') {
        if (this.sourceLoading) return;
        this.sourceLoading = true;
        this.sourceError = '';
        await this.service.render();
        try {
            const { code, data } = await wiz.call('source_companies', { text });
            if (code == 200) {
                this.sourceCompanies = data.rows || [];
                this.sourceLoaded = true;
            } else {
                this.sourceError = data?.message || '기업 목록을 불러오지 못했습니다.';
            }
        } catch (e) {
            this.sourceError = '기업 목록을 불러오지 못했습니다.';
        }
        this.sourceLoading = false;
        await this.service.render();
    }

    public visibleSourceCompanies() {
        const text = (this.sourceSearch || '').trim().toLowerCase();
        const rows = this.sourceCompanies.filter((company: any) => {
            if (this.sourceFilter !== 'all' && company.source_status !== this.sourceFilter) return false;
            if (!text) return true;
            return (company.company_name || '').toLowerCase().includes(text)
                || (company.registed_number || '').toLowerCase().includes(text)
                || (company.source_status_label || '').toLowerCase().includes(text);
        });
        return rows.slice(0, 120);
    }

    public sourceCount(status: string = 'all'): number {
        if (status === 'all') return this.sourceCompanies.length;
        return this.sourceCompanies.filter((company: any) => company.source_status === status).length;
    }

    public selectedSourceLabel(): string {
        const selected = this.foundSource || this.sourceCompanies.find((company: any) => company.id === this.form.source_company_id);
        if (!selected) return '기업을 선택해주세요';
        return selected.company_name || selected.label || '선택된 기업';
    }

    public selectedSourceMeta(): string {
        const selected = this.foundSource || this.sourceCompanies.find((company: any) => company.id === this.form.source_company_id);
        if (!selected) return '클릭하면 검토기업/투자기업 목록이 아래에 표시됩니다';
        return [selected.source_status_label, selected.registed_number].filter((value: any) => !!value).join(' · ');
    }

    public sourceFilterClass(status: string): string {
        if (this.sourceFilter === status) return 'border-cyan-500 bg-cyan-50 text-cyan-800';
        return 'border-zinc-200 bg-white text-zinc-600 hover:border-cyan-300 hover:text-cyan-700';
    }

    public async toggleSourcePicker() {
        this.sourceOpen = !this.sourceOpen;
        if (this.sourceOpen && !this.sourceLoaded && !this.sourceLoading) {
            await this.loadSourceCompanies();
            return;
        }
        await this.service.render();
    }

    public sourceCompanyClass(company: any): string {
        if (this.form.source_company_id === company.id) return 'border-cyan-400 bg-cyan-50 text-cyan-900';
        return 'border-zinc-200 bg-white text-zinc-800 hover:border-cyan-300 hover:bg-cyan-50';
    }

    public async load(page: number = 1) {
        if (this.loading) return;
        this.loading = true;
        this.loaded = false;
        this.search.page = page;
        this.pagination.current = page;
        await this.service.render();

        const { code, data } = await wiz.call('search', {
            status: this.status || 'recommended',
            text: this.search.text,
            page: this.search.page,
            dump: this.search.dump
        });

        if (code == 200) {
            this.rows = data.rows || [];
            this.selectedIds = {};
            this.title = data.title || this.config.title;
            const startpage = Math.floor((page - 1) / 10) * 10 + 1;
            this.pagination.start = startpage;
            this.pagination.end = data.lastpage || 1;
        }

        this.loaded = true;
        this.loading = false;
        await this.service.render();
    }

    public applyForm(data: any) {
        const status = data?.status || this.form.status || this.status || 'recommended';
        const form = { ...this.emptyForm(status), ...(data || {}), status };
        form.contacts = this.normalizeContacts(form.contacts, form);
        this.form = form;
        this.foundSource = data?.source_company || null;
    }

    public normalizeContacts(items: any, fallback: any = {}) {
        const rows = Array.isArray(items) ? items : [];
        const contacts = rows
            .filter((item: any) => item && typeof item === 'object')
            .map((item: any) => ({
                name: item.name || '',
                title: item.title || '',
                phone: item.phone || '',
                email: item.email || '',
                user_id: item.user_id || '',
                invited: !!item.invited,
                invited_at: item.invited_at || '',
                invite_status: item.invite_status || ''
            }));

        if (!contacts.length && (fallback.manager || fallback.manager_email || fallback.manager_phone)) {
            contacts.push({
                name: fallback.manager || '',
                title: '',
                phone: fallback.manager_phone || '',
                email: fallback.manager_email || '',
                user_id: '',
                invited: false,
                invited_at: '',
                invite_status: ''
            });
        }
        return contacts;
    }

    public normalizeFiles(items: any) {
        if (!Array.isArray(items)) return [];
        return items
            .filter((item: any) => item && typeof item === 'object')
            .map((item: any) => ({ name: item.name || item.filename || '', url: item.url || item.file || '' }))
            .filter((item: any) => item.name || item.url);
    }

    public selectedRows() {
        return this.rows.filter((row: any) => this.selectedIds[row.id]);
    }

    public selectedCount(): number {
        return this.selectedRows().length;
    }

    public allVisibleSelected(): boolean {
        const rows = this.rows.filter((row: any) => !!row.id);
        return rows.length > 0 && rows.every((row: any) => !!this.selectedIds[row.id]);
    }

    public async toggleAllVisible() {
        const checked = !this.allVisibleSelected();
        this.rows.forEach((row: any) => {
            if (row.id) this.selectedIds[row.id] = checked;
        });
        await this.service.render();
    }

    public async toggleRow(row: any) {
        if (!row?.id) return;
        this.selectedIds[row.id] = !this.selectedIds[row.id];
        await this.service.render();
    }

    public async addContact() {
        if (!Array.isArray(this.form.contacts)) this.form.contacts = [];
        this.form.contacts.push({ name: '', title: '', phone: '', email: '', invited: false });
        await this.service.render();
    }

    public async removeContact(index: number) {
        if (!Array.isArray(this.form.contacts)) return;
        this.form.contacts.splice(index, 1);
        await this.service.render();
    }

    public lipsValues() {
        return {
            recommended_month: this.form.recommended_month,
            operating_period: this.form.operating_period,
            investment_amount: this.form.investment_amount,
            program_name: this.form.program_name,
            lead_manager: this.form.lead_manager,
            task_number: this.form.task_number,
            residency_status: this.form.residency_status,
            lips_manager: this.form.lips_manager,
            recommendation_reason: this.form.recommendation_reason,
            selection_date: this.form.selection_date,
            graduation_date: this.form.graduation_date,
            memo: this.form.memo
        };
    }

    public sourceCompanyPayload(company: any) {
        const payload = { ...(company || {}) };
        return {
            ...payload,
            id: '',
            status: this.form.status || this.status || 'recommended',
            source_company_id: payload.id || payload.source_company_id || '',
            source_company: company || null,
            exists: false
        };
    }

    public applyLookupPayload(payload: any) {
        const lips = this.lipsValues();
        const merged = payload?.exists ? { ...this.form, ...(payload || {}) } : { ...this.form, ...(payload || {}), ...lips };
        this.applyForm({ ...merged, status: this.form.status || payload?.status });
    }

    public async openCreate() {
        this.sourceSearch = '';
        this.sourceFilter = 'all';
        this.sourceOpen = false;
        this.applyForm(this.emptyForm(this.status || 'recommended'));
        this.modalOpen = true;
        await this.service.render();
    }

    public async editItem(row: any) {
        if (!row?.id) return;
        const { code, data } = await wiz.call('get', { id: row.id });
        if (code !== 200) {
            await this.service.alert.error(data?.message || '립스 기업 정보를 불러오지 못했습니다.');
            return;
        }
        this.sourceSearch = '';
        this.sourceFilter = 'all';
        this.sourceOpen = false;
        this.applyForm(data.data || {});
        this.modalOpen = true;
        await this.service.render();
    }

    public openManagement(row: any) {
        if (!row?.id) return;
        const status = row.status || this.status || 'recommended';
        this.service.href(`/admin/lips/company/${status}/${row.id}/overview`);
    }

    public async selectSourceCompany() {
        if (!this.form.source_company_id || this.lookupLoading) return false;
        this.lookupLoading = true;
        await this.service.render();
        const { code, data } = await wiz.call('lookup_company', {
            source_company_id: this.form.source_company_id,
            status: this.form.status || this.status || 'recommended'
        });
        this.lookupLoading = false;

        if (code !== 200) {
            await this.service.alert.error(data?.message || '기업 정보를 조회하지 못했습니다.');
            await this.service.render();
            return false;
        }

        const payload = data.data || {};
        this.applyLookupPayload(payload);
        this.sourceOpen = false;
        if (payload.exists) await this.service.alert.success('이미 등록된 립스 기업 정보를 불러왔습니다.');
        else await this.service.alert.success('선택한 기업의 기본정보를 불러왔습니다.');
        await this.service.render();
        return true;
    }

    public async chooseSourceCompany(company: any) {
        if (!company?.id) return;
        this.applyLookupPayload(this.sourceCompanyPayload(company));
        this.sourceOpen = false;
        await this.service.render();
        await this.selectSourceCompany();
    }

    public closeModal() {
        if (this.saving) return;
        this.modalOpen = false;
        this.foundSource = null;
        this.service.render();
    }

    public async save() {
        if (this.saving) return;
        if (this.lookupLoading) {
            await this.service.alert.error('기업 정보를 불러오는 중입니다. 잠시 후 다시 저장해주세요.');
            return;
        }
        const selected = this.sourceCompanies.find((company: any) => company.id === this.form.source_company_id);
        if (selected && !this.form.company_name) {
            this.applyLookupPayload(this.sourceCompanyPayload(selected));
        }
        if (this.form.source_company_id && !this.form.company_name) {
            const loaded = await this.selectSourceCompany();
            if (!loaded) return;
        }
        if (!this.form.source_company_id && !this.form.registed_number) {
            await this.service.alert.error('기업명을 선택해주세요.');
            return;
        }
        if (!this.form.company_name) {
            await this.service.alert.error('기업명을 입력해주세요.');
            return;
        }

        this.form.contacts = this.normalizeContacts(this.form.contacts, this.form);
        this.saving = true;
        await this.service.render();
        const { code, data } = await wiz.call('save', {
            data: JSON.stringify(this.form),
            status: this.form.status || this.status || 'recommended'
        });
        this.saving = false;

        if (code !== 200) {
            await this.service.alert.error(data?.message || '저장에 실패했습니다.');
            await this.service.render();
            return;
        }

        this.modalOpen = false;
        this.foundSource = null;
        await this.service.alert.success('저장되었습니다.');
        await this.load(this.pagination.current || 1);
    }

    public async uploadTo(list: any[]) {
        if (!Array.isArray(list)) return;
        const files = await this.service.file.select();
        if (!files || files.length === 0) return;
        await this.service.loading.show();
        for (let i = 0; i < files.length; i++) {
            const fd = new FormData();
            fd.append('upload', files[i]);
            const { url } = await this.service.file.upload('/file/upload', fd, async () => { });
            list.push({ name: files[i].name, url });
        }
        await this.service.loading.hide();
        await this.service.render();
    }

    public removeAttachment(list: any[], index: number) {
        if (!Array.isArray(list)) return;
        list.splice(index, 1);
        this.service.render();
    }

    public async openNotification(row: any = null) {
        const rows = row?.id ? [row] : this.selectedRows();
        if (!rows.length) {
            await this.service.alert.error('알림을 보낼 기업을 선택해주세요.');
            return;
        }
        this.notification = this.emptyNotification(rows);
        this.notificationOpen = true;
        await this.service.render();
    }

    public closeNotification() {
        if (this.notificationSending) return;
        this.notificationOpen = false;
        this.notification = this.emptyNotification();
        this.service.render();
    }

    public async sendNotification() {
        if (this.notificationSending || !this.notification.ids?.length) return;
        if (!this.notification.message) {
            await this.service.alert.error('알림 내용을 입력해주세요.');
            return;
        }
        this.notificationSending = true;
        await this.service.render();
        const { code, data } = await wiz.call('send_bulk_notification', {
            data: JSON.stringify(this.notification)
        });
        this.notificationSending = false;
        if (code !== 200) {
            await this.service.alert.error(data?.message || '알림 발송에 실패했습니다.');
            await this.service.render();
            return;
        }
        this.notificationOpen = false;
        this.notification = this.emptyNotification();
        this.selectedIds = {};
        await this.service.alert.success(`알림을 발송했습니다. (${data.sent || 0}건)`);
        await this.service.render();
    }

    public formatMoney(value: any): string {
        const amount = Number(value) || 0;
        if (!amount) return '-';
        return amount.toLocaleString() + '원';
    }

    public openCompany(row: any) {
        const companyId = row.source_company_id || row.id;
        if (!companyId) return;
        this.service.href(`/admin/invest/company/${companyId}/overview`);
    }
}

export default PortalLpsysadminLipsCompanyListComponent;